import { Component, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { VendorDropDown } from '../../models/customer/customer-model';
import { CustomerService } from '../../services/customer/customer.service';
import { ToastsManager } from 'ng2-toastr';
import { MultiPOReport, DefaultReportCommon } from '../../models/PurchaseOrder/purchase-order-detail-view.model';
@Component({
    selector: 'app-multi-po-report',
    templateUrl: './multi-po-report.component.html',
    styleUrls: ['./multi-po-report.component.css']
})
/** MultiPoReport component*/
export class MultiPoReportComponent {
  public report: MultiPOReport[]=[];
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
  regDate: Date;
  endRegDate: Date;
  startDate: string;
  endDate: string;
  vendorName: string;
  reportFrom: string;
  reportTo: string;
  public vendorID: string;
  public VID: number;
  total: number;
    /** MultiPoReport ctor */
  constructor(

    private readonly purchaseOrderService: PurchaseOrderService,
    private _avRoute: ActivatedRoute, public toastr: ToastsManager, vcr: ViewContainerRef
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.endRegDate = new Date();
    this.regDate = new Date();
    this.vendorName = "";
    this.reportFrom = "";
    this.reportTo = "";
    this.total = 0;
  }
  selectStartDate(e) {
    if (e != null) {
      this.startDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.endDate = e;
      this.regDate = e;
      this.endRegDate = new Date(this.regDate);
    }
  }



  ShowResult() {
   
    if (this.startDate === undefined) {
      this.toastr.error("Please Select Date ", "Error");
      return;
    }
    try {
      var fd = new Date(this.startDate).toDateString();
      this.purchaseOrderService.GetMultiPurchaseOrdersReport(fd).subscribe(
        data => {
          this.report = data;
          if (this.report.length == 0) {
            this.toastr.success("No Record Found", "Success");
          }
          this.reportFrom = this.report[0].dateFrom;
          this.reportTo = this.report[0].dateTo;
          this.toastr.success("Report has been generated successfully", "Success");
        }
      )
    } catch (e) {
      this.toastr.error("Something went wrong", "Error");
    }

  }
  print(): void {
    let printContents, popupWin;
    printContents = (document.getElementById('print-section') as HTMLElement).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Order Detail</title>
          <style>
            body{font-family:Arial!important}
            table{font-family:Arial!important;width:100%!important;max-width:100%!important;border: 1px solid #ddd!important;}
            .checkoutProductImage{width: 55px !important;height: auto !important;margin: 8px !important;vertical-align: middle;}
            table th, table td {vertical-align: middle !important;padding: 10px;border-bottom: 1px solid #ddd!important;text-align:left!important}
            table th{background-color:#fafafa!important}
            a{text-decoration:none!important;}
            .invoice-img-show{display: block;}
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  } 
}



// WEBPACK FOOTER //
// ./src/app/order-components/multi-po-report/multi-po-report.component.ts